import React from "react";
import { decidirTransicionConsulta } from "../../../../utils/consultaAbierta";
import { CITA_ESTADO_EN_CONSULTA, CITA_ESTADO_FINALIZADA } from "../../../../utils/citaFinalizadaAlert";

/**
 * Aviso + acción de apertura de la consulta. Sustituye al botón «Iniciar
 * consulta» que vivía en la vieja sección CONSULTA. La lógica de transición es
 * la MISMA (utils/consultaAbierta) que ya usaban el botón y el bloqueo de
 * formularios; el backend sigue siendo la autoridad.
 */
export default function BannerConsulta({ cita, onIniciar, iniciando }) {
  const destino = decidirTransicionConsulta(cita);
  const idEstado = Number(cita?.estado_cita?.idestado_cita);

  if (idEstado === CITA_ESTADO_EN_CONSULTA) return null; // ya abierta: nada que mostrar
  if (idEstado === CITA_ESTADO_FINALIZADA) {
    return (
      <div className="cev__franja" style={{ background: "var(--warning-bg)", color: "var(--warning-text)" }}>
        <span aria-hidden="true">🔒</span>
        La atención está finalizada. La historia clínica ya no puede modificarse.
      </div>
    );
  }
  if (destino !== CITA_ESTADO_EN_CONSULTA) return null;

  return (
    <div
      className="cev__franja"
      style={{ background: "var(--warning-bg)", color: "var(--warning-text)", alignItems: "center" }}
      role="status"
    >
      <span aria-hidden="true">▶</span>
      <span style={{ flexGrow: 1 }}>
        La consulta aún no está abierta. Los campos clínicos se habilitan al iniciarla.
      </span>
      <button type="button" className="cev__btn cev__btn--pri cev__btn--sm" onClick={onIniciar} disabled={iniciando}>
        {iniciando ? "Iniciando…" : "Iniciar consulta"}
      </button>
    </div>
  );
}
